import React, { useEffect, useState } from 'react';
import './FileUpload.css';
const FileUpload = ({
  label,
  required,
  onChange,
  error,
  inputClassName = '',
  isDisabled = false,
  accept = '',
  multiple = false,
  note = '',
  value
   
}) => {
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(value);
  const fileInputRef = React.createRef();
  // Update when value changes (when navigating back to the page)
  useEffect(() => {
    setFileUrl(value);
    
    // If value exists but no file is selected, ensure we notify parent
    if (value && !file) {
      // Create a special object that signals we want to keep the existing file
      const existingFileObj = {
        isExistingFile: true,
        url: value,
        name: getFileNameFromUrl(value)
      };
      // This ensures the parent component is aware we have an existing file
      if (onChange) onChange(existingFileObj);
    }
  }, [value]);
  
  // Handle file selection
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile); // Update the state with the selected file
      setFileUrl(null);
      if (onChange) onChange(selectedFile); // Notify parent component if `onChange` is provided
    }
  };
  
  // Open file in a new tab
  const handleViewFile = () => {
    if (file) {
      const tempFileUrl = URL.createObjectURL(file);
      window.open(tempFileUrl, '_blank');
    }
  };
  
  const handleViewValue = () => {
    if (fileUrl) {
      window.open(fileUrl, '_blank');
    }
  };
  const handleClearFile = () => {
    setFile(null);
    setFileUrl(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Reset the file input
    }
    if (onChange) onChange(null);
  };
  // Extract filename from URL
  const getFileNameFromUrl = (url) => {
    if (!url) return '';
    const parts = url.split('/');
    return parts[parts.length - 1];
  };

  return (
    <div className="form-group">
      <label>
        {label} {required && <span style={{ color: 'red' }}>*</span>}
      </label>
      <div className={`file-upload-wrapper ${error ? 'error' : ''}`}>
        <input
          ref={fileInputRef}
          type="file"
          onChange={handleFileChange}
          className={`file-upload ${error?'error':""} ${isDisabled ? 'isDisabled' : ''} ${inputClassName}`}
          disabled={isDisabled}
          accept={accept}
          multiple={multiple}
        />
        
        {/* Add a label to show existing file */}
        {!file && value && (
          <span className="file-exists-label">
            File: {getFileNameFromUrl(value)}
          </span>
        )}
        
        {file &&
          <button
            onClick={handleViewFile}
            className="view-icon-button"
            type="button"
            title="View File"
          >
            👁️
          </button>
        }
        
        {!file && value && (
          <button
            onClick={handleViewValue}
            className="view-icon-button"
            type="button"
            title="View File"
          >
            👁️ Link
          </button>
        )}
      </div>
      {error && <div className="error-message">{error}</div>}
      {note && <div className="file-upload-note">{note}</div>}
    </div>
  );
};
export default FileUpload;